<template>
  <div class="wysiwyg-content my-3">
    <div v-html="item.content.content">
      {{ item.content.content }}
    </div>
  </div>
</template>

<script>
import { Blok } from 'src/modules/vsf-storyblok-module/components'

export default {
  name: 'WYSIWYGBlok',
  extends: Blok
}
</script>
